import React, { FC } from 'react';
import styles from './BuildingTypeCard.module.css';

interface BuildingTypeCardProps {
    imageSrc: string,
    title: string,
    description: string,
    ps: string,
    active: boolean,
    autoFocus: boolean,
    onClick: () => void
}

const BuildingTypeCard: FC<BuildingTypeCardProps> = ({ imageSrc, title, description, ps, active, autoFocus, onClick }) => (
    <span className={styles.cardType}>
        <button autoFocus={autoFocus} onKeyUp={(e)=>{ if(e.key === 'Enter') onClick() }} onClick={() => { onClick(); }} className={`${styles.buildingType} ${active ? styles.active : ''}`}>
            <img src={imageSrc}></img>
            <span className={styles.title}>
                {title}
            </span>
            <span className={styles.description}>
                {description}
            </span>
            <span className={styles.ps}>
                {ps}
            </span>
        </button>
    </span>
);

export default BuildingTypeCard;
